
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { AlertTriangle } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export const GeolocationUnavailable: React.FC = () => {
  return (
    <Card className="w-full max-w-md mx-auto">
      <CardHeader>
        <CardTitle className="text-center">Distance de balle</CardTitle>
      </CardHeader>
      <CardContent>
        <Alert variant="destructive" className="mb-4">
          <AlertTriangle className="h-4 w-4" />
          <AlertTitle>Géolocalisation non disponible</AlertTitle>
          <AlertDescription>
            Votre appareil ne prend pas en charge la géolocalisation, qui est nécessaire pour mesurer la distance de balle.
          </AlertDescription>
        </Alert>
      </CardContent>
    </Card>
  );
};
